import styles from "./AssessmentTension.module.scss";
import { Card } from "./Card";
import photo1 from "../../../assets/assessmentTension1.jpg";
import photo2 from "../../../assets/assessmentTension2.jpg";
import photo3 from "../../../assets/assessmentTension3.jpg";

const cards = [
    {
        text: (
            <>
                <strong>Dynamic tension</strong> leads to stiffness or tension
                in the body
            </>
        ),
        position: "01",
        photo: photo1,
    },
    {
        text: (
            <>
                <strong>Static tension</strong> causes overheating or
                inflammatory processes
            </>
        ),
        position: "02",
        photo: photo2,
    },
    {
        text: (
            <>
                <strong>A negative attitude</strong> leads to intoxication,
                excess weight, benign and malignant tumors.
            </>
        ),
        position: "03",
        photo: photo3,
    },
];

export const AssessmentTension = () => {
    return (
        <div className={styles.AssessmentTension}>
            <div className={styles.title}>
                A person with mental tension feels{" "}
                <span>three types of problems:</span>
            </div>
            <div className={styles.content}>
                {cards.map((card, index) => {
                    return (
                        <Card
                            text={card.text}
                            position={card.position}
                            photo={card.photo}
                            key={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};
